import * as React from 'react';
import { createComponent } from '@lit-labs/react';

function e(t) {
  return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(t);
}

function t(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function i(e, t) {
  for (var i = 0; i < t.length; i++) {
    var r = t[i];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function r(e, t, r) {
  return t && i(e.prototype, t), r && i(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function n(e) {
  return (n = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function o(e, t) {
  return (o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function s(e, t) {
  if (t && ("object" == typeof t || "function" == typeof t)) return t;
  if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
  return function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }(e);
}

function a(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var i,
        r = n(e);

    if (t) {
      var o = n(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else i = r.apply(this, arguments);

    return s(this, i);
  };
}

function d(e, t) {
  for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = n(e)););

  return e;
}

function l() {
  return (l = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, i) {
    var r = d(e, t);

    if (r) {
      var n = Object.getOwnPropertyDescriptor(r, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : i) : n.value;
    }
  }).apply(this, arguments);
}

function c(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

function u(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var i = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == i) return;
    var r,
        n,
        o = [],
        s = !0,
        a = !1;

    try {
      for (i = i.call(e); !(s = (r = i.next()).done) && (o.push(r.value), !t || o.length !== t); s = !0);
    } catch (e) {
      a = !0, n = e;
    } finally {
      try {
        s || null == i.return || i.return();
      } finally {
        if (a) throw n;
      }
    }

    return o;
  }(e, t) || p(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function h(e) {
  return function (e) {
    if (Array.isArray(e)) return m(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || p(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function p(e, t) {
  if (e) {
    if ("string" == typeof e) return m(e, t);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? m(e, t) : void 0;
  }
}

function m(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var i = 0, r = new Array(t); i < t; i++) r[i] = e[i];

  return r;
}

function f(e, t) {
  var i = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

  if (!i) {
    if (Array.isArray(e) || (i = p(e)) || t && e && "number" == typeof e.length) {
      i && (e = i);

      var r = 0,
          n = function () {};

      return {
        s: n,
        n: function () {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: n
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var o,
      s = !0,
      a = !1;
  return {
    s: function () {
      i = i.call(e);
    },
    n: function () {
      var e = i.next();
      return s = e.done, e;
    },
    e: function (e) {
      a = !0, o = e;
    },
    f: function () {
      try {
        s || null == i.return || i.return();
      } finally {
        if (a) throw o;
      }
    }
  };
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function g(e, t, i, r) {
  var n,
      o = arguments.length,
      s = o < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, i) : r;
  if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t, i, r);else for (var a = e.length - 1; a >= 0; a--) (n = e[a]) && (s = (o < 3 ? n(s) : o > 3 ? n(t, i, s) : n(t, i)) || s);
  return o > 3 && s && Object.defineProperty(t, i, s), s;
}

function v(e, t) {
  if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
}

for (var y, b = 256, w = []; b--;) w[b] = (b + 256).toString(16).substring(1);

function _() {
  var e,
      t = 0,
      i = "";

  if (!y || b + 16 > 256) {
    for (y = Array(t = 256); t--;) y[t] = 256 * Math.random() | 0;

    t = b = 0;
  }

  for (; t < 16; t++) e = y[b + t], i += 6 == t ? w[15 & e | 64] : 8 == t ? w[63 & e | 128] : w[e], 1 & t && t > 1 && t < 11 && (i += "-");

  return b++, i;
}
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */


const S = window,
      $ = S.ShadowRoot && (void 0 === S.ShadyCSS || S.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype,
      E = Symbol(),
      A = new WeakMap();

class O {
  constructor(e, t, i) {
    if (this._$cssResult$ = !0, i !== E) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = e, this.t = t;
  }

  get styleSheet() {
    let e = this.o;
    const t = this.t;

    if ($ && void 0 === e) {
      const i = void 0 !== t && 1 === t.length;
      i && (e = A.get(t)), void 0 === e && ((this.o = e = new CSSStyleSheet()).replaceSync(this.cssText), i && A.set(t, e));
    }

    return e;
  }

  toString() {
    return this.cssText;
  }

}

const k = $ ? e => e : e => e instanceof CSSStyleSheet ? (e => {
  let t = "";

  for (const i of e.cssRules) t += i.cssText;

  return (e => new O("string" == typeof e ? e : e + "", void 0, E))(t);
})(e) : e
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
;
var M;

const C = window,
      j = C.trustedTypes,
      I = j ? j.emptyScript : "",
      x = C.reactiveElementPolyfillSupport,
      R = {
  toAttribute(e, t) {
    switch (t) {
      case Boolean:
        e = e ? I : null;
        break;

      case Object:
      case Array:
        e = null == e ? e : JSON.stringify(e);
    }

    return e;
  },

  fromAttribute(e, t) {
    let i = e;

    switch (t) {
      case Boolean:
        i = null !== e;
        break;

      case Number:
        i = null === e ? null : Number(e);
        break;

      case Object:
      case Array:
        try {
          i = JSON.parse(e);
        } catch (e) {
          i = null;
        }

    }

    return i;
  }

},
      D = (e, t) => t !== e && (t == t || e == e),
      P = {
  attribute: !0,
  type: String,
  converter: R,
  reflect: !1,
  hasChanged: D
};

class T extends HTMLElement {
  constructor() {
    super(), this._$Ei = new Map(), this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this.u();
  }

  static addInitializer(e) {
    var t;
    this.finalize(), (null !== (t = this.h) && void 0 !== t ? t : this.h = []).push(e);
  }

  static get observedAttributes() {
    this.finalize();
    const e = [];
    return this.elementProperties.forEach((t, i) => {
      const r = this._$Ep(i, t);

      void 0 !== r && (this._$Ev.set(r, i), e.push(r));
    }), e;
  }

  static createProperty(e, t = P) {
    if (t.state && (t.attribute = !1), this.finalize(), this.elementProperties.set(e, t), !t.noAccessor && !this.prototype.hasOwnProperty(e)) {
      const i = "symbol" == typeof e ? Symbol() : "__" + e,
            r = this.getPropertyDescriptor(e, i, t);
      void 0 !== r && Object.defineProperty(this.prototype, e, r);
    }
  }

  static getPropertyDescriptor(e, t, i) {
    return {
      get() {
        return this[t];
      },

      set(r) {
        const n = this[e];
        this[t] = r, this.requestUpdate(e, n, i);
      },

      configurable: !0,
      enumerable: !0
    };
  }

  static getPropertyOptions(e) {
    return this.elementProperties.get(e) || P;
  }

  static finalize() {
    if (this.hasOwnProperty("finalized")) return !1;
    this.finalized = !0;
    const e = Object.getPrototypeOf(this);

    if (e.finalize(), void 0 !== e.h && (this.h = [...e.h]), this.elementProperties = new Map(e.elementProperties), this._$Ev = new Map(), this.hasOwnProperty("properties")) {
      const e = this.properties,
            t = [...Object.getOwnPropertyNames(e), ...Object.getOwnPropertySymbols(e)];

      for (const i of t) this.createProperty(i, e[i]);
    }

    return this.elementStyles = this.finalizeStyles(this.styles), !0;
  }

  static finalizeStyles(e) {
    const t = [];

    if (Array.isArray(e)) {
      const i = new Set(e.flat(1 / 0).reverse());

      for (const e of i) t.unshift(k(e));
    } else void 0 !== e && t.push(k(e));

    return t;
  }

  static _$Ep(e, t) {
    const i = t.attribute;
    return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof e ? e.toLowerCase() : void 0;
  }

  u() {
    var e;
    this._$E_ = new Promise(e => this.enableUpdating = e), this._$AL = new Map(), this._$Eg(), this.requestUpdate(), null === (e = this.constructor.h) || void 0 === e || e.forEach(e => e(this));
  }

  addController(e) {
    var t, i;
    (null !== (t = this._$ES) && void 0 !== t ? t : this._$ES = []).push(e), void 0 !== this.renderRoot && this.isConnected && (null === (i = e.hostConnected) || void 0 === i || i.call(e));
  }

  removeController(e) {
    var t;
    null === (t = this._$ES) || void 0 === t || t.splice(this._$ES.indexOf(e) >>> 0, 1);
  }

  _$Eg() {
    this.constructor.elementProperties.forEach((e, t) => {
      this.hasOwnProperty(t) && (this._$Ei.set(t, this[t]), delete this[t]);
    });
  }

  createRenderRoot() {
    var e;
    const t = null !== (e = this.shadowRoot) && void 0 !== e ? e : this.attachShadow(this.constructor.shadowRootOptions);
    return ((e, t) => {
      $ ? e.adoptedStyleSheets = t.map(e => e instanceof CSSStyleSheet ? e : e.styleSheet) : t.forEach(t => {
        const i = document.createElement("style"),
              r = S.litNonce;
        void 0 !== r && i.setAttribute("nonce", r), i.textContent = t.cssText, e.appendChild(i);
      });
    })(t, this.constructor.elementStyles), t;
  }

  connectedCallback() {
    var e;
    void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (e = this._$ES) || void 0 === e || e.forEach(e => {
      var t;
      return null === (t = e.hostConnected) || void 0 === t ? void 0 : t.call(e);
    });
  }

  enableUpdating(e) {}

  disconnectedCallback() {
    var e;
    null === (e = this._$ES) || void 0 === e || e.forEach(e => {
      var t;
      return null === (t = e.hostDisconnected) || void 0 === t ? void 0 : t.call(e);
    });
  }

  attributeChangedCallback(e, t, i) {
    this._$AK(e, i);
  }

  _$EO(e, t, i = P) {
    var r;

    const n = this.constructor._$Ep(e, i);

    if (void 0 !== n && !0 === i.reflect) {
      const o = (void 0 !== (null === (r = i.converter) || void 0 === r ? void 0 : r.toAttribute) ? i.converter : R).toAttribute(t, i.type);
      this._$El = e, null == o ? this.removeAttribute(n) : this.setAttribute(n, o), this._$El = null;
    }
  }

  _$AK(e, t) {
    var i;

    const r = this.constructor,
          n = r._$Ev.get(e);

    if (void 0 !== n && this._$El !== n) {
      const e = r.getPropertyOptions(n),
            o = "function" == typeof e.converter ? {
        fromAttribute: e.converter
      } : void 0 !== (null === (i = e.converter) || void 0 === i ? void 0 : i.fromAttribute) ? e.converter : R;
      this._$El = n, this[n] = o.fromAttribute(t, e.type), this._$El = null;
    }
  }

  requestUpdate(e, t, i) {
    let r = !0;
    void 0 !== e && (((i = i || this.constructor.getPropertyOptions(e)).hasChanged || D)(this[e], t) ? (this._$AL.has(e) || this._$AL.set(e, t), !0 === i.reflect && this._$El !== e && (void 0 === this._$EC && (this._$EC = new Map()), this._$EC.set(e, i))) : r = !1), !this.isUpdatePending && r && (this._$E_ = this._$Ej());
  }

  async _$Ej() {
    this.isUpdatePending = !0;

    try {
      await this._$E_;
    } catch (e) {
      Promise.reject(e);
    }

    const e = this.scheduleUpdate();
    return null != e && (await e), !this.isUpdatePending;
  }

  scheduleUpdate() {
    return this.performUpdate();
  }

  performUpdate() {
    var e;
    if (!this.isUpdatePending) return;
    this.hasUpdated, this._$Ei && (this._$Ei.forEach((e, t) => this[t] = e), this._$Ei = void 0);
    let t = !1;
    const i = this._$AL;

    try {
      t = this.shouldUpdate(i), t ? (this.willUpdate(i), null === (e = this._$ES) || void 0 === e || e.forEach(e => {
        var t;
        return null === (t = e.hostUpdate) || void 0 === t ? void 0 : t.call(e);
      }), this.update(i)) : this._$Ek();
    } catch (e) {
      throw t = !1, this._$Ek(), e;
    }

    t && this._$AE(i);
  }

  willUpdate(e) {}

  _$AE(e) {
    var t;
    null === (t = this._$ES) || void 0 === t || t.forEach(e => {
      var t;
      return null === (t = e.hostUpdated) || void 0 === t ? void 0 : t.call(e);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
  }

  _$Ek() {
    this._$AL = new Map(), this.isUpdatePending = !1;
  }

  get updateComplete() {
    return this.getUpdateComplete();
  }

  getUpdateComplete() {
    return this._$E_;
  }

  shouldUpdate(e) {
    return !0;
  }

  update(e) {
    void 0 !== this._$EC && (this._$EC.forEach((e, t) => this._$EO(t, this[t], e)), this._$EC = void 0), this._$Ek();
  }

  updated(e) {}

  firstUpdated(e) {}

}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */


var H;
T.finalized = !0, T.elementProperties = new Map(), T.elementStyles = [], T.shadowRootOptions = {
  mode: "open"
}, null == x || x({
  ReactiveElement: T
}), (null !== (M = C.reactiveElementVersions) && void 0 !== M ? M : C.reactiveElementVersions = []).push("1.6.1");

const N = window,
      U = N.trustedTypes,
      z = U ? U.createPolicy("lit-html", {
  createHTML: e => e
}) : void 0,
      W = `lit$${(Math.random() + "").slice(9)}$`,
      L = "?" + W,
      B = `<${L}>`,
      q = document,
      F = (e = "") => q.createComment(e),
      V = e => null === e || "object" != typeof e && "function" != typeof e,
      K = Array.isArray,
      G = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,
      J = /-->/g,
      Z = />/g,
      Y = RegExp(">|[ \t\n\f\r](?:([^\\s\"'>=/]+)([ \t\n\f\r]*=[ \t\n\f\r]*(?:[^ \t\n\f\r\"'`<>=]|(\"|')|))|$)", "g"),
      Q = /'/g,
      X = /"/g,
      ee = /^(?:script|style|textarea|title)$/i,
      te = (e => (t, ...i) => ({
  _$litType$: e,
  strings: t,
  values: i
}))(1),
      ie = Symbol.for("lit-noChange"),
      re = Symbol.for("lit-nothing"),
      ne = new WeakMap(),
      oe = q.createTreeWalker(q, 129, null, !1),
      se = (e, t) => {
  const i = e.length - 1,
        r = [];
  let n,
      o = 2 === t ? "<svg>" : "",
      s = G;

  for (let t = 0; t < i; t++) {
    const i = e[t];
    let a,
        d,
        l = -1,
        c = 0;

    for (; c < i.length && (s.lastIndex = c, d = s.exec(i), null !== d);) c = s.lastIndex, s === G ? "!--" === d[1] ? s = J : void 0 !== d[1] ? s = Z : void 0 !== d[2] ? (ee.test(d[2]) && (n = RegExp("</" + d[2], "g")), s = Y) : void 0 !== d[3] && (s = Y) : s === Y ? ">" === d[0] ? (s = null != n ? n : G, l = -1) : void 0 === d[1] ? l = -2 : (l = s.lastIndex - d[2].length, a = d[1], s = void 0 === d[3] ? Y : '"' === d[3] ? X : Q) : s === X || s === Q ? s = Y : s === J || s === Z ? s = G : (s = Y, n = void 0);

    const u = s === Y && e[t + 1].startsWith("/>") ? " " : "";
    o += s === G ? i + B : l >= 0 ? (r.push(a), i.slice(0, l) + "$lit$" + i.slice(l) + W + u) : i + W + (-2 === l ? (r.push(void 0), t) : u);
  }

  const a = o + (e[i] || "<?>") + (2 === t ? "</svg>" : "");
  if (!Array.isArray(e) || !e.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return [void 0 !== z ? z.createHTML(a) : a, r];
};

class ae {
  constructor({
    strings: e,
    _$litType$: t
  }, i) {
    let r;
    this.parts = [];
    let n = 0,
        o = 0;
    const s = e.length - 1,
          a = this.parts,
          [d, l] = se(e, t);

    if (this.el = ae.createElement(d, i), oe.currentNode = this.el.content, 2 === t) {
      const e = this.el.content,
            t = e.firstChild;
      t.remove(), e.append(...t.childNodes);
    }

    for (; null !== (r = oe.nextNode()) && a.length < s;) {
      if (1 === r.nodeType) {
        if (r.hasAttributes()) {
          const e = [];

          for (const t of r.getAttributeNames()) if (t.endsWith("$lit$") || t.startsWith(W)) {
            const i = l[o++];

            if (e.push(t), void 0 !== i) {
              const e = r.getAttribute(i.toLowerCase() + "$lit$").split(W),
                    t = /([.?@])?(.*)/.exec(i);
              a.push({
                type: 1,
                index: n,
                name: t[2],
                strings: e,
                ctor: "." === t[1] ? he : "?" === t[1] ? me : "@" === t[1] ? fe : ue
              });
            } else a.push({
              type: 6,
              index: n
            });
          }

          for (const t of e) r.removeAttribute(t);
        }

        if (ee.test(r.tagName)) {
          const e = r.textContent.split(W),
                t = e.length - 1;

          if (t > 0) {
            r.textContent = U ? U.emptyScript : "";

            for (let i = 0; i < t; i++) r.append(e[i], F()), oe.nextNode(), a.push({
              type: 2,
              index: ++n
            });

            r.append(e[t], F());
          }
        }
      } else if (8 === r.nodeType) if (r.data === L) a.push({
        type: 2,
        index: n
      });else {
        let e = -1;

        for (; -1 !== (e = r.data.indexOf(W, e + 1));) a.push({
          type: 7,
          index: n
        }), e += W.length - 1;
      }

      n++;
    }
  }

  static createElement(e, t) {
    const i = q.createElement("template");
    return i.innerHTML = e, i;
  }

}

function de(e, t, i = e, r) {
  var n, o, s, a;
  if (t === ie) return t;
  let d = void 0 !== r ? null === (n = i._$Co) || void 0 === n ? void 0 : n[r] : i._$Cl;
  const l = V(t) ? void 0 : t._$litDirective$;
  return (null == d ? void 0 : d.constructor) !== l && (null === (o = null == d ? void 0 : d._$AO) || void 0 === o || o.call(d, !1), void 0 === l ? d = void 0 : (d = new l(e), d._$AT(e, i, r)), void 0 !== r ? (null !== (s = (a = i)._$Co) && void 0 !== s ? s : a._$Co = [])[r] = d : i._$Cl = d), void 0 !== d && (t = de(e, d._$AS(e, t.values), d, r)), t;
}

class le {
  constructor(e, t) {
    this.u = [], this._$AN = void 0, this._$AD = e, this._$AM = t;
  }

  get parentNode() {
    return this._$AM.parentNode;
  }

  get _$AU() {
    return this._$AM._$AU;
  }

  v(e) {
    var t;
    const {
      el: {
        content: i
      },
      parts: r
    } = this._$AD,
          n = (null !== (t = null == e ? void 0 : e.creationScope) && void 0 !== t ? t : q).importNode(i, !0);
    oe.currentNode = n;
    let o = oe.nextNode(),
        s = 0,
        a = 0,
        d = r[0];

    for (; void 0 !== d;) {
      if (s === d.index) {
        let t;
        2 === d.type ? t = new ce(o, o.nextSibling, this, e) : 1 === d.type ? t = new d.ctor(o, d.name, d.strings, this, e) : 6 === d.type && (t = new ge(o, this, e)), this.u.push(t), d = r[++a];
      }

      s !== (null == d ? void 0 : d.index) && (o = oe.nextNode(), s++);
    }

    return n;
  }

  p(e) {
    let t = 0;

    for (const i of this.u) void 0 !== i && (void 0 !== i.strings ? (i._$AI(e, i, t), t += i.strings.length - 2) : i._$AI(e[t])), t++;
  }

}

class ce {
  constructor(e, t, i, r) {
    var n;
    this.type = 2, this._$AH = re, this._$AN = void 0, this._$AA = e, this._$AB = t, this._$AM = i, this.options = r, this._$Cm = null === (n = null == r ? void 0 : r.isConnected) || void 0 === n || n;
  }

  get _$AU() {
    var e, t;
    return null !== (t = null === (e = this._$AM) || void 0 === e ? void 0 : e._$AU) && void 0 !== t ? t : this._$Cm;
  }

  get parentNode() {
    let e = this._$AA.parentNode;
    const t = this._$AM;
    return void 0 !== t && 11 === e.nodeType && (e = t.parentNode), e;
  }

  get startNode() {
    return this._$AA;
  }

  get endNode() {
    return this._$AB;
  }

  _$AI(e, t = this) {
    e = de(this, e, t), V(e) ? e === re || null == e || "" === e ? (this._$AH !== re && this._$AR(), this._$AH = re) : e !== this._$AH && e !== ie && this.g(e) : void 0 !== e._$litType$ ? this.$(e) : void 0 !== e.nodeType ? this.T(e) : (e => K(e) || "function" == typeof (null == e ? void 0 : e[Symbol.iterator]))(e) ? this.k(e) : this.g(e);
  }

  O(e, t = this._$AB) {
    return this._$AA.parentNode.insertBefore(e, t);
  }

  T(e) {
    this._$AH !== e && (this._$AR(), this._$AH = this.O(e));
  }

  g(e) {
    this._$AH !== re && V(this._$AH) ? this._$AA.nextSibling.data = e : this.T(q.createTextNode(e)), this._$AH = e;
  }

  $(e) {
    var t;
    const {
      values: i,
      _$litType$: r
    } = e,
          n = "number" == typeof r ? this._$AC(e) : (void 0 === r.el && (r.el = ae.createElement(r.h, this.options)), r);
    if ((null === (t = this._$AH) || void 0 === t ? void 0 : t._$AD) === n) this._$AH.p(i);else {
      const e = new le(n, this),
            t = e.v(this.options);
      e.p(i), this.T(t), this._$AH = e;
    }
  }

  _$AC(e) {
    let t = ne.get(e.strings);
    return void 0 === t && ne.set(e.strings, t = new ae(e)), t;
  }

  k(e) {
    K(this._$AH) || (this._$AH = [], this._$AR());
    const t = this._$AH;
    let i,
        r = 0;

    for (const n of e) r === t.length ? t.push(i = new ce(this.O(F()), this.O(F()), this, this.options)) : i = t[r], i._$AI(n), r++;

    r < t.length && (this._$AR(i && i._$AB.nextSibling, r), t.length = r);
  }

  _$AR(e = this._$AA.nextSibling, t) {
    var i;

    for (null === (i = this._$AP) || void 0 === i || i.call(this, !1, !0, t); e && e !== this._$AB;) {
      const t = e.nextSibling;
      e.remove(), e = t;
    }
  }

  setConnected(e) {
    var t;
    void 0 === this._$AM && (this._$Cm = e, null === (t = this._$AP) || void 0 === t || t.call(this, e));
  }

}

class ue {
  constructor(e, t, i, r, n) {
    this.type = 1, this._$AH = re, this._$AN = void 0, this.element = e, this.name = t, this._$AM = r, this.options = n, i.length > 2 || "" !== i[0] || "" !== i[1] ? (this._$AH = Array(i.length - 1).fill(new String()), this.strings = i) : this._$AH = re;
  }

  get tagName() {
    return this.element.tagName;
  }

  get _$AU() {
    return this._$AM._$AU;
  }

  _$AI(e, t = this, i, r) {
    const n = this.strings;
    let o = !1;
    if (void 0 === n) e = de(this, e, t, 0), o = !V(e) || e !== this._$AH && e !== ie, o && (this._$AH = e);else {
      const r = e;
      let s, a;

      for (e = n[0], s = 0; s < n.length - 1; s++) a = de(this, r[i + s], t, s), a === ie && (a = this._$AH[s]), o || (o = !V(a) || a !== this._$AH[s]), a === re ? e = re : e !== re && (e += (null != a ? a : "") + n[s + 1]), this._$AH[s] = a;
    }
    o && !r && this.j(e);
  }

  j(e) {
    e === re ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != e ? e : "");
  }

}

class he extends ue {
  constructor() {
    super(...arguments), this.type = 3;
  }

  j(e) {
    this.element[this.name] = e === re ? void 0 : e;
  }

}

const pe = U ? U.emptyScript : "";

class me extends ue {
  constructor() {
    super(...arguments), this.type = 4;
  }

  j(e) {
    e && e !== re ? this.element.setAttribute(this.name, pe) : this.element.removeAttribute(this.name);
  }

}

class fe extends ue {
  constructor(e, t, i, r, n) {
    super(e, t, i, r, n), this.type = 5;
  }

  _$AI(e, t = this) {
    var i;
    if ((e = null !== (i = de(this, e, t, 0)) && void 0 !== i ? i : re) === ie) return;
    const r = this._$AH,
          n = e === re && r !== re || e.capture !== r.capture || e.once !== r.once || e.passive !== r.passive,
          o = e !== re && (r === re || n);
    n && this.element.removeEventListener(this.name, this, r), o && this.element.addEventListener(this.name, this, e), this._$AH = e;
  }

  handleEvent(e) {
    var t, i;
    "function" == typeof this._$AH ? this._$AH.call(null !== (i = null === (t = this.options) || void 0 === t ? void 0 : t.host) && void 0 !== i ? i : this.element, e) : this._$AH.handleEvent(e);
  }

}

class ge {
  constructor(e, t, i) {
    this.element = e, this.type = 6, this._$AN = void 0, this._$AM = t, this.options = i;
  }

  get _$AU() {
    return this._$AM._$AU;
  }

  _$AI(e) {
    de(this, e);
  }

}

const ve = N.litHtmlPolyfillSupport;
null == ve || ve(ae, ce), (null !== (H = N.litHtmlVersions) && void 0 !== H ? H : N.litHtmlVersions = []).push("2.6.1");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

var ye, be;

class we extends T {
  constructor() {
    super(...arguments), this.renderOptions = {
      host: this
    }, this._$Dt = void 0;
  }

  createRenderRoot() {
    var e, t;
    const i = super.createRenderRoot();
    return null !== (e = (t = this.renderOptions).renderBefore) && void 0 !== e || (t.renderBefore = i.firstChild), i;
  }

  update(e) {
    const t = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Dt = ((e, t, i) => {
      var r, n;
      const o = null !== (r = null == i ? void 0 : i.renderBefore) && void 0 !== r ? r : t;
      let s = o._$litPart$;

      if (void 0 === s) {
        const e = null !== (n = null == i ? void 0 : i.renderBefore) && void 0 !== n ? n : null;
        o._$litPart$ = s = new ce(t.insertBefore(F(), e), e, void 0, null != i ? i : {});
      }

      return s._$AI(e), s;
    })(t, this.renderRoot, this.renderOptions);
  }

  connectedCallback() {
    var e;
    super.connectedCallback(), null === (e = this._$Dt) || void 0 === e || e.setConnected(!0);
  }

  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), null === (e = this._$Dt) || void 0 === e || e.setConnected(!1);
  }

  render() {
    return ie;
  }

}

we.finalized = !0, we._$litElement$ = !0, null === (ye = globalThis.litElementHydrateSupport) || void 0 === ye || ye.call(globalThis, {
  LitElement: we
});
const _e = globalThis.litElementPolyfillSupport;
null == _e || _e({
  LitElement: we
}), (null !== (be = globalThis.litElementVersions) && void 0 !== be ? be : globalThis.litElementVersions = []).push("3.2.0");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

const Se = (e, t) => "method" === t.kind && t.descriptor && !("value" in t.descriptor) ? { ...t,

  finisher(i) {
    i.createProperty(t.key, e);
  }

} : {
  kind: "field",
  key: Symbol(),
  placement: "own",
  descriptor: {},
  originalKey: t.key,

  initializer() {
    "function" == typeof t.initializer && (this[t.key] = t.initializer.call(this));
  },

  finisher(i) {
    i.createProperty(t.key, e);
  }

};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */


function $e(e) {
  return (t, i) => void 0 !== i ? ((e, t, i) => {
    t.constructor.createProperty(i, e);
  })(e, t, i) : Se(e, t);
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */


function Ee(e, t) {
  return (({
    finisher: e,
    descriptor: t
  }) => (i, r) => {
    var n;

    if (void 0 === r) {
      const r = null !== (n = i.originalKey) && void 0 !== n ? n : i.key,
            o = null != t ? {
        kind: "method",
        placement: "prototype",
        key: r,
        descriptor: t(i.key)
      } : { ...i,
        key: r
      };
      return null != e && (o.finisher = function (t) {
        e(t, r);
      }), o;
    }

    {
      const n = i.constructor;
      void 0 !== t && Object.defineProperty(i, r, t(r)), null == e || e(n, r);
    }
  })({
    descriptor: i => {
      const r = {
        get() {
          var t, i;
          return null !== (i = null === (t = this.renderRoot) || void 0 === t ? void 0 : t.querySelector(e)) && void 0 !== i ? i : null;
        },

        enumerable: !0,
        configurable: !0
      };

      if (t) {
        const t = "symbol" == typeof i ? Symbol() : "__" + i;

        r.get = function () {
          var i, r;
          return void 0 === this[t] && (this[t] = null !== (r = null === (i = this.renderRoot) || void 0 === i ? void 0 : i.querySelector(e)) && void 0 !== r ? r : null), this[t];
        };
      }

      return r;
    }
  });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */


var Ae;
null === (Ae = window.HTMLSlotElement) || void 0 === Ae || Ae.prototype.assignedElements;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

const Oe = 1;
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

const ke = (e => (...t) => ({
  _$litDirective$: e,
  values: t
}))(class extends class {
  constructor(e) {}

  get _$AU() {
    return this._$AM._$AU;
  }

  _$AT(e, t, i) {
    this._$Ct = e, this._$AM = t, this._$Ci = i;
  }

  _$AS(e, t) {
    return this.update(e, t);
  }

  update(e, t) {
    return this.render(...t);
  }

} {
  constructor(e) {
    var t;
    if (super(e), e.type !== Oe || "style" !== e.name || (null === (t = e.strings) || void 0 === t ? void 0 : t.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
  }

  render(e) {
    return Object.keys(e).reduce((t, i) => {
      const r = e[i];
      return null == r ? t : t + `${i = i.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${r};`;
    }, "");
  }

  update(e, [t]) {
    const {
      style: i
    } = e.element;

    if (void 0 === this.vt) {
      this.vt = new Set();

      for (const e in t) this.vt.add(e);

      return this.render(t);
    }

    this.vt.forEach(e => {
      null == t[e] && (this.vt.delete(e), e.includes("-") ? i.removeProperty(e) : i[e] = "");
    });

    for (const e in t) {
      const r = t[e];
      null != r && (this.vt.add(e), e.includes("-") ? i.setProperty(e, r) : i[e] = r);
    }

    return ie;
  }

});

var Me = new (r(function e() {
  t(this, e), this._components = [];
}))(),
    Ce = function (e, t) {
  var i = "The dashboard component encountered an error";
  "string" == typeof (null == t ? void 0 : t.dashboardId) && (i += " for dashboard with id ".concat(t.dashboardId)), "string" == typeof (null == t ? void 0 : t.dashboardSlug) && (i += " for dashboard with slug ".concat(t.dashboardSlug)), "string" == typeof (null == t ? void 0 : t.container) && (i += " in container ".concat(t.container)), e && (i += ":\n".concat(e), console.error(i));
},
    je = {
  appServer: "https://app.cumul.io/",
  apiHost: "https://api.cumul.io/",
  dashboardId: null,
  dashboardSlug: null,
  container: null,
  key: null,
  token: null,
  language: "auto",
  editMode: null,
  screenMode: null,
  switchScreenModeOnResize: !0,
  itemId: null,
  mainColor: "",
  accentColor: "",
  itemDimensions: {
    width: "auto",
    height: "auto"
  },
  loaderBackground: "#f9f9f9",
  loaderFontColor: "#5a5a5a",
  loaderSpinnerColor: "rgba(255, 165, 0, 0.7)",
  loaderSpinnerBackground: "rgba(169, 169, 169, 0.14)",
  timezoneId: null
},
    Ie = [{
  mode: "mobile",
  width: [150, 767]
}, {
  mode: "tablet",
  width: [768, 1199]
}, {
  mode: "desktop",
  width: [1200, 1599]
}, {
  mode: "largeScreen",
  width: [1600, 9999]
}, {
  mode: "fixed",
  width: []
}],
    xe = {
  initializing: {
    en: "Initializing...",
    nl: "Laden...",
    fr: "Chargement..."
  },
  errorDashboard: {
    en: "Oops, we could not load this dashboard!",
    nl: "Oeps, we konden het dashboard niet laden.",
    fr: "Le chargement a echoué."
  },
  errorItem: {
    en: "Oops, we could not load this item!",
    nl: "Oeps, we konden de grafiek niet laden.",
    fr: "Le chargement a echoué."
  }
},
    Re = function (e) {
  return JSON.parse(JSON.stringify(e));
},
    De = function t(i, r) {
  return Object.entries(r).forEach(function (r) {
    var n = u(r, 2),
        o = n[0],
        s = n[1];
    o in i ? void 0 === i[o] ? i[o] = s : i[o] = function (t) {
      return t && "object" === e(t);
    }(s) ? t(i[o], s) : i[o] : i[o] = s;
  }), i;
};

function Pe(e, t, i) {
  e.promises[t] && (e.promises[t].resolve(i), delete e.promises[t]);
}

function Te(e, t, i) {
  e.promises[t] && (e.promises[t].reject(i), delete e.promises[t]);
}

function He(e) {
  var t = {
    width: "100%",
    height: "100%"
  };
  return e.params.loaderBackground && !e.iframeLoaded && (t.background = e.params.loaderBackground), t;
}

function Ne(e) {
  var t = e.params.itemDimensions.height || je.itemDimensions.height,
      i = e.params.itemDimensions.width || je.itemDimensions.width;
  e.params.itemEmbedding && "auto" !== t ? e.iframeHeight = "".concat(t, "px") : e.params.itemEmbedding ? e.iframeHeight = "200px" : ["editFull", "editLimited"].includes(e.params.editMode) ? e.iframeHeight = "100%" : e.iframeHeight = "400px", e.iframeWidth = e.params.itemEmbedding && "auto" !== i ? "".concat(i, "px") : "100%";
  var r = {
    height: e.iframeHeight,
    width: e.iframeWidth
  };
  return e.iframeLoaded ? r.opacity = 1 : e.error ? (r.opacity = 1, r.width = "100%", r.height = "400px") : r.opacity = 0, r;
}

function Ue(e, t) {
  return "".concat(e, "px solid ").concat(t);
}

var ze,
    We,
    Le,
    Be,
    qe,
    Fe,
    Ve = function (e, t, i) {
  var r = _();

  return null != t && t.contentWindow ? (t.contentWindow.postMessage({
    action: "exportDashboard",
    format: i || "png",
    _version: e.VERSION,
    requestId: r
  }, "*"), new Promise(function (t, i) {
    e.promises[r] = {
      resolve: t,
      reject: i
    }, setTimeout(function () {
      if (e.promises[r]) {
        e.promises[r].reject(new Error("exportDashboard request timed out.")), delete e.promises[r];
      }
    }, 12e5);
  })) : Promise.reject(new Error("Cannot retrieve contentWindow."));
},
    Ke = function (t, i) {
  if ((t.dashboardId || t.dashboardSlug) && null != i && i.contentWindow) {
    var r = _();

    return i.contentWindow.postMessage({
      action: "getAccessibleDashboards",
      _version: t.VERSION,
      requestId: r
    }, "*"), new Promise(function (e, i) {
      t.promises[r] = {
        resolve: e,
        reject: i
      }, setTimeout(function () {
        if (t.promises[r]) {
          t.promises[r].reject(new Error("getAccessibleDashboards request timed out.")), delete t.promises[r];
        }
      }, 2e3);
    });
  }

  var n = new Promise(function (e, i) {
    !function () {
      try {
        window.fetch("".concat(String(t.params.apiHost), "0.1.0/authorization"), {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          headers: {
            "Content-Type": "application/json"
          },
          redirect: "follow",
          body: JSON.stringify({
            action: "get",
            version: "0.1.0",
            key: t.authKey,
            token: t.authToken,
            find: {
              where: {
                id: t.authKey
              },
              attributes: ["id", "integration_id"],
              include: [{
                model: "User",
                attributes: ["id", "name", "locale_id"],
                include: [{
                  model: "Group"
                }]
              }]
            }
          })
        }).then(function (e) {
          return e.json();
        }).then(function (t) {
          t && t.rows && 0 !== t.rows.length && t.rows[0].user && t.rows[0].integration_id ? (t.rows[0].user.userGroups = t.rows[0].user.groups.map(function (e) {
            return e.id;
          }), delete t.rows[0].user.groups, e({
            integrationId: t.rows[0].integration_id,
            user: t.rows[0].user
          })) : i();
        });
      } catch (e) {
        i(e);
      }
    }();
  });
  return new Promise(function (i, r) {
    !function () {
      try {
        n.then(function (r) {
          window.fetch("".concat(String(t.params.apiHost), "0.1.0/securable"), {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            headers: {
              "Content-Type": "application/json"
            },
            redirect: "follow",
            body: JSON.stringify({
              action: "get",
              version: "0.1.0",
              key: t.authKey,
              token: t.authToken,
              find: {
                where: {
                  type: "dashboard",
                  is_variant: !1
                },
                attributes: ["id", "name", "modified_at"],
                order: [["modified_at", "desc"]],
                include: [{
                  model: "Tag",
                  attributes: ["tag"]
                }, {
                  model: "User",
                  attributes: ["id", "name"]
                }, {
                  model: "Group",
                  attributes: ["id", "name", "public"]
                }, {
                  model: "Integration",
                  attributes: ["id", "name"]
                }]
              }
            })
          }).then(function (e) {
            return e.json();
          }).then(function (n) {
            var o = n.rows.length > 0 ? function (t, i, r, n) {
              var o,
                  s = function (e, t) {
                var i,
                    r,
                    n = e.users.find(function (e) {
                  return e.id === t.id;
                }),
                    o = n && n.userAccessRight ? {
                  flagRead: n.userAccessRight.flagRead,
                  flagUse: n.userAccessRight.flagUse,
                  flagModify: n.userAccessRight.flagModify,
                  flagOwn: n.userAccessRight.flagOwn
                } : {
                  flagRead: !1,
                  flagUse: !1,
                  flagModify: !1,
                  flagOwn: !1
                },
                    s = f(e.groups.filter(function (e) {
                  return t.userGroups.includes(e.id) || !0 === e.public;
                }).map(function (e) {
                  if (e.groupAccessRight) return e.groupAccessRight;
                }));

                try {
                  for (s.s(); !(r = s.n()).done;) {
                    var a = r.value;
                    !o.flagRead && a.flagRead && (o.flagRead = a.flagRead), !o.flagUse && a.flagUse && (o.flagUse = a.flagUse), !o.flagModify && a.flagModify && (o.flagModify = a.flagModify), !o.flagOwn && a.flagOwn && (o.flagOwn = a.flagOwn);
                  }
                } catch (e) {
                  s.e(e);
                } finally {
                  s.f();
                }

                var d,
                    l = f((null === (i = e.integrations) || void 0 === i ? void 0 : i.length) > 0 ? e.integrations.map(function (e) {
                  if (e.integrationAccessRight) return e.integrationAccessRight;
                }) : []);

                try {
                  for (l.s(); !(d = l.n()).done;) {
                    var c = d.value;
                    !o.flagRead && c.flagRead && (o.flagRead = c.flagRead), !o.flagUse && c.flagUse && (o.flagUse = c.flagUse), !o.flagModify && c.flagModify && (o.flagModify = c.flagModify);
                  }
                } catch (e) {
                  l.e(e);
                } finally {
                  l.f();
                }

                return o;
              },
                  a = function (t, i) {
                return null == t ? "" : "object" !== e(t) || 0 === Object.keys(t).length ? "object" === e(t) && 0 === Object.keys(t).length ? "" : t : (null == (r = i && t[i] ? t[i] : t[Object.keys(t)[0]]) && (r = ""), r);
                var r;
              },
                  d = [],
                  l = f(t);

              try {
                for (l.s(); !(o = l.n()).done;) {
                  var c,
                      u = o.value,
                      p = {
                    accessibleBy: [],
                    accessRights: s(u, r),
                    id: u.id,
                    modifiedAt: u.modified_at,
                    name: a(u.name, n.language),
                    slug: null,
                    tags: u.tags.map(function (e) {
                      return e.tag;
                    }).sort(function (e, t) {
                      return e.localeCompare(t);
                    })
                  },
                      m = u.integrations.find(function (e) {
                    return e.id === i;
                  });
                  null != m && null !== (c = m.integrationAccessRight) && void 0 !== c && c.slug && (p.slug = m.integrationAccessRight.slug);
                  var g = u.users.map(function (e) {
                    return {
                      model: "User",
                      id: e.id,
                      name: a(e.name, r.locale_id)
                    };
                  }),
                      v = u.groups.map(function (e) {
                    return {
                      model: "Group",
                      id: e.id,
                      name: a(e.name, r.locale_id) || {}
                    };
                  }),
                      y = u.integrations.map(function (e) {
                    return {
                      model: "Integration",
                      id: e.id,
                      name: a(e.name, r.locale_id) || {}
                    };
                  });
                  p.accessibleBy = [].concat(h(g), h(v), h(y)), d.push(p);
                }
              } catch (e) {
                l.e(e);
              } finally {
                l.f();
              }

              return d;
            }(n.rows, r.integrationId, r.user, t) : [];
            i(o);
          });
        }).catch(function (e) {
          r(e);
        });
      } catch (e) {
        r(e);
      }
    }();
  });
},
    Ge = function (e, t, i) {
  return t ? (t.contentWindow.postMessage({
    action: "refreshData",
    id: i || null,
    _version: e.VERSION
  }, "*"), Promise.resolve()) : Promise.reject(new Error("Cannot retrieve contentWindow."));
},
    Je = function (e) {
  e.dimensions || (e.params.error = !0, Ce("Got no valid dimensions.", e.params));
  var t = [],
      i = "",
      r = 0,
      n = 0;
  !e.params.switchScreenModeOnResize && e.currentScreenMode && (e.params.screenMode = e.currentScreenMode);
  var o = Object.keys(e.dimensions);
  if (e.dimensions && o && "fixed" === o[0]) i = "fixed", r = e.dimensions.fixed[0], n = e.dimensions.fixed[1];else {
    if (e.params.itemEmbedding) for (var s = o[0], a = Re(s), d = function () {
      var t = c[l],
          i = o.find(function (e) {
        return e === t;
      });
      i ? a = Re(i) : e.dimensions[t] = e.dimensions[a];
    }, l = 0, c = ["mobile", "tablet", "desktop", "largeScreen"]; l < c.length; l++) d();
    var u,
        h = f(o);

    try {
      var p = function () {
        var i = u.value;

        if (["mobile", "tablet", "desktop", "largeScreen"].includes(i)) {
          var r = Ie.find(function (e) {
            return e.mode === i;
          });
          r.height = e.dimensions[i][1] || 50, t.push(r);
        }
      };

      for (h.s(); !(u = h.n()).done;) p();
    } catch (e) {
      h.e(e);
    } finally {
      h.f();
    }

    if (t.map(function (e) {
      return e.mode;
    }).includes(e.params.screenMode) || (e.params.screenMode = "auto"), "auto" === e.params.screenMode) {
      t.sort(function (e, t) {
        return ["mobile", "tablet", "desktop", "largeScreen"].indexOf(e.mode) - ["mobile", "tablet", "desktop", "largeScreen"].indexOf(t.mode);
      });
      var m,
          g = f(t);

      try {
        for (g.s(); !(m = g.n()).done;) {
          var v = m.value;
          e.params.itemEmbedding && e.params.itemDimensions && "auto" !== e.params.itemDimensions.width && "auto" === e.params.itemDimensions.height ? v.width[0] < e.params.itemDimensions.width && (i = v.mode, r = Number.parseInt(e.params.itemDimensions.width, 10), n = e.dimensions[i][1]) : v.width[0] < e.containerWidth && (i = v.mode, e.params.itemEmbedding ? (r = e.params.itemDimensions && e.params.itemDimensions.width && "auto" !== e.params.itemDimensions.width ? Number.parseInt(e.params.itemDimensions.width, 10) : Math.min(e.containerWidth, v.width[1]), n = e.params.itemDimensions && e.params.itemDimensions.height && "auto" !== e.params.itemDimensions.height ? Number.parseInt(e.params.itemDimensions.height, 10) : e.dimensions[i][1], e.params.itemDimensions && "auto" !== e.params.itemDimensions.width && "auto" === e.params.itemDimensions.height && (r = Number.parseInt(e.params.itemDimensions.width, 10), n = e.dimensions[i][1])) : (r = Math.max(Math.min(v.width[1], e.containerWidth), v.width[0]), n = v.height));
        }
      } catch (e) {
        g.e(e);
      } finally {
        g.f();
      }
    } else {
      var y = t.find(function (t) {
        return t.mode === e.params.screenMode;
      });
      i = e.params.screenMode, r = Math.max(Math.min(y.width[1], e.containerWidth), y.width[0]), n = y.height, e.params.itemEmbedding && (e.params.itemDimensions && e.params.itemDimensions.width && "auto" !== e.params.itemDimensions.width && (r = Number.parseInt(e.params.itemDimensions.width, 10)), e.params.itemDimensions && e.params.itemDimensions.height && "auto" !== e.params.itemDimensions.height && (n = Number.parseInt(e.params.itemDimensions.height, 10)));
    }

    !i && t.length > 0 && (i = t[0].mode, r = t[0].width[0], n = t[0].height);
  }
  e.currentScreenMode = i;
  var b = {};
  b.height = 0 === n ? "100%" : "".concat(String(n), "px"), b.width = 0 === r ? "100%" : "".concat(String(r), "px"), b.opacity = 1, ["editFull", "editLimited"].includes(e.params.editMode) ? (b.height = "100%", b.width = "100%") : e.params.itemEmbedding && e.params.itemDimensions ? (b.height = "auto" === e.params.itemDimensions.height ? b.height : "".concat(String(e.params.itemDimensions.height).replace("px", ""), "px"), b.width = "auto" === e.params.itemDimensions.width ? b.width : "".concat(String(e.params.itemDimensions.width).replace("px", ""), "px")) : (b.height = 0 === n ? "100%" : "".concat(String(n), "px"), b.width = 0 === r ? "100%" : "".concat(String(r), "px")), e.currentScreenMode = i, e.iframeStyle = b;
},
    Ze = ((e, ...t) => {
  const i = 1 === e.length ? e[0] : t.reduce((t, i, r) => t + (e => {
    if (!0 === e._$cssResult$) return e.cssText;
    if ("number" == typeof e) return e;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + e + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + e[r + 1], e[0]);
  return new O(i, e, E);
})(ze || (ze = c(["\n  @-webkit-keyframes spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  :host {\n    position: relative;\n    width: 100%;\n  }\n\n  .cio-embed-dashboard {\n    background: transparent;\n    padding: 0;\n    border: 0;\n  }\n\n  .cio-container-loader {\n    width: 100%;\n    position: relative;\n  }\n\n  .cio-lc {\n    margin: 0 auto;\n  }\n\n  .cio-loading-message {\n    width: 100%;\n    height: 20px;\n    text-align: center;\n    margin-bottom: 16px;\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 14px;\n  }\n\n  .cio-loading-circle {\n    box-sizing: border-box;\n    margin: 16px auto;\n    position: relative;\n    text-indent: -9999em;\n    animation: spin 0.6s infinite linear;\n  }\n\n  .cio-loading-circle,\n  .cio-loading-circle:after {\n    border-radius: 50%;\n    width: 32px;\n    height: 32px;\n  }\n\n  .itemEmbedding:after {\n    width: 24px;\n    height: 24px;\n  }\n\n  .cio-error {\n    background: transparent;\n    padding: 48px 0;\n    margin: 0 auto;\n    width: 80%;\n    border: 0;\n    text-align: center;\n    min-height: 192px;\n  }\n\n  .dashboard-error {\n    font-size: 30px;\n    background: transparent;\n    padding: 48px 0;\n    margin: 0 auto;\n    width: 80%;\n    border: 0;\n    text-align: center;\n    min-height: 192px;\n  }\n\n  .cio-loader {\n    top: 0;\n    left: 0;\n    width: 100%;\n    min-height: 400px;\n    position: absolute;\n    transition-duration: 0.3s;\n  }\n"]))),
    Ye = function (e) {
  for (var t = !1, i = "", r = (document.body || document.documentElement).style, n = {
    svg: !(!("createElementNS" in document) || !document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect),
    flexbox: "" === r.webkitFlexWrap || "" === r.flexWrap,
    postMessage: !!window.postMessage
  }, o = 0, s = ["svg", "flexbox", "postMessage"]; o < s.length; o++) {
    var a = s[o];
    n[a] || (t = !0, e.browserNotSupported = e.browserNotSupported || [], e.browserNotSupported.push(a), i += "Your browser does not support: ".concat(a, "\n"));
  }

  var d = window.navigator.userAgent,
      l = d.includes("MSIE"),
      c = d.includes("Trident/");
  (l || c) && (t = !0, i = "IE is not supported."), t && Ce(i);
},
    Qe = function (e) {
  var t;
  (e.params.error || e.browserNotSupported.length > 0) && (e.params.error = !0, e.browserNotSupported && (t = "Browser is not supported."));
  var i = xe.initializing[e.params.language] || xe.initializing.en;
  return e.browserNotSupported || e.params.error ? {
    loadingMsg: i,
    errorMsg: t
  } : {
    loadingMsg: i,
    errorMsg: ""
  };
},
    Xe = Je,
    et = function (t) {
  for (var i = [], r = ["mobile", "tablet", "desktop", "largeScreen", "fixed", "auto"], n = 0, o = Object.keys(je); n < o.length; n++) {
    var s = o[n];
    null === t.params[s] && delete t.params[s];
  }

  t.params = De(t.params, je), t.params.dashboardId && "string" == typeof t.params.dashboardId || t.params.dashboardSlug && "string" == typeof t.params.dashboardSlug || (delete t.params.dashboardId, delete t.params.dashboardSlug);

  for (var a = 0, d = ["appServer", "language", "apiHost"]; a < d.length; a++) {
    var l = d[a];
    "string" != typeof t.params[l] && (delete t.params[l], i.push("".concat(l, " needs to be of type string.")));
  }

  for (var c = 0, u = ["key", "token", "screenMode", "timezoneId", "itemId", "container", "loaderBackground", "loaderFontColor", "loaderSpinnerColor", "loaderSpinnerBackground"]; c < u.length; c++) {
    var h = u[c];
    "string" != typeof t.params[h] && null !== t.params[h] && void 0 !== t.params[h] && (delete t.params[h], i.push("".concat(h, " needs to be of type string or empty.")));
  }

  if (t.params.screenMode && !r.includes(t.params.screenMode)) {
    var p = r.map(function (e) {
      return '"'.concat(e, '"');
    }).join(", ");
    i.push('"screenMode" needs should be one of these types: '.concat(p)), t.params.screenMode = "auto";
  }

  t.params.itemId && (t.params.itemEmbedding = !0);

  for (var m = 0, f = ["itemDimensions"]; m < f.length; m++) {
    var g = f[m];
    "object" !== e(t.params[g]) && null !== t.params[g] && (delete t.params[g], i.push("".concat(g, " needs to be of type object or empty.")));
  }

  if ("boolean" != typeof t.params.switchScreenModeOnResize && (i.push("switchScreenModeOnResize needs to be of type boolean."), t.params.switchScreenModeOnResize = !0), t.params.itemDimensions) for (var v = 0, y = ["width", "height"]; v < y.length; v++) {
    var b = y[v];
    ["string", "number"].includes(e(t.params.itemDimensions[b])) || null === t.params.itemDimensions[b] || i.push("itemDimensions ".concat(b, " needs to be of type string, number or empty."));
  }
  t.params = De(t.params, je), t.params.screenMode && "auto" !== t.params.screenMode && (t.params.switchScreenModeOnResize = !1), "auto" !== t.params.itemDimensions.width && (t.params.itemDimensions.width = Number.parseInt("".concat(t.params.itemDimensions.width).replace("px", ""), 10) || "auto"), "auto" !== t.params.itemDimensions.height && (t.params.itemDimensions.height = Number.parseInt("".concat(t.params.itemDimensions.height).replace("px", ""), 10) || "auto"), t.params.itemEmbedding = !!t.params.itemId, (t.params.error || i.length) && Ce(i.join("\n"), t.params);
},
    tt = Ie,
    it = function (e) {
  return e ? e.endsWith("/") ? e : "".concat(e, "/") : "";
},
    rt = je,
    nt = function (e) {
  var t = [],
      i = e.params,
      r = i.appServer,
      n = i.language,
      o = i.loaderBackground,
      s = i.loaderSpinnerColor,
      a = i.loaderSpinnerBackground,
      d = i.loaderFontColor,
      l = i.screenMode,
      c = i.key,
      u = i.token,
      h = i.timezoneId,
      p = i.itemEmbedding,
      m = i.itemDimensions,
      f = i.dashboardId,
      g = i.dashboardSlug,
      v = i.itemId,
      y = i.mainColor,
      b = i.accentColor,
      w = i.editMode;
  n && "auto" !== n && t.push("language=" + n), o && t.push("ldrbg=".concat(o)), d && t.push("ldrftclr=".concat(d)), s && t.push("ldrspclr=".concat(s)), a && t.push("ldrspbg=".concat(a)), y && t.push("mainColor=".concat(y)), b && t.push("accentColor=".concat(b)), l && "auto" !== l && t.push("screenMode=" + l), h && t.push("timezoneId=" + h), p && m && m.width && t.push("width=" + m.width), p && m && m.height && t.push("height=" + m.height), w && t.push("editMode=" + w);

  var _ = c && u ? "#" + c + ":" + u : "";

  return t.push("version=" + (e.VERSION || "0.0.0-shared-cumulio")), function (e) {
    var t = new Set([".", "/"]);
    if (!e) return "about:blank";
    var i,
        r = e.replace(/[^\u0020-\u007E]/gim, "").trim();
    if (i = r, t.has(i[0])) return r;
    var n = r.match(/^([^:]+):/gm);
    if (!n) return r;
    var o = n[0];
    return /^(%20|\s)*(javascript|data)/im.test(o) ? "about:blank" : r;
  }(p ? "".concat(r, "i/").concat(f || g, "/").concat(v, "?").concat(encodeURIComponent(t.join("&"))).concat(_) : "".concat(r, "i/").concat(f || g, "?").concat(encodeURIComponent(t.join("&"))).concat(_));
},
    ot = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && o(e, t);
  }(s, we);
  var i = a(s);

  function s(e) {
    var r;
    return t(this, s), (r = i.call(this)).language = "auto", r.screenMode = "auto", r.switchScreenModeOnResize = !0, r.editMode = "view", r.iframeStyle = {}, r._containerStyle = {}, r._loaderStyle = {}, r._lcStyle = {}, r._loadingCircleStyle = {}, r._containerLoaderStyle = {}, r._loaderMsg = "", r._itemEmbedding = !1, r.browserError = !1, r.browserErrorMsg = "", r.dashboardError = !1, r.browserNotSupported = [], r.VERSION = "2.1.0-wc-cumulio", r.loaderSize = 32, r.borderWidth = 3, r.minHeight = 400, r._containerId = _(), r._iframeId = "cio-dashboard-".concat(r._containerId), r.iframeLoaded = !1, r.promises = {}, r.setInputParameters(e), r.params = r._setOptions(), r._onResize = function () {
      var e;

      if (null === (e = r.shadowRoot) || void 0 === e ? void 0 : e.querySelector(".dashboard-container")) {
        if (r.containerWidth = r.container.clientWidth, r.params.switchScreenModeOnResize && "auto" === r.params.screenMode) {
          var t,
              i = f(tt);

          try {
            for (i.s(); !(t = i.n()).done;) {
              var n = t.value;
              n.width[0] <= window.innerWidth && window.innerWidth <= n.width[1] && (r.currentScreenMode = n.mode);
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
        }

        r.iframeLoaded && r._calculateDimAfterDashboardLoaded();
      }
    }, r._resizeObserver = new ResizeObserver(function () {
      r._onResize();
    }), r;
  }

  return r(s, [{
    key: "setInputParameters",
    value: function (e) {
      if (e) {
        for (var t = 0, i = ["dashboardId", "dashboardSlug", "itemId", "language", "screenMode", "switchScreenModeOnResize", "accentColor", "mainColor", "authToken", "authKey", "editMode", "loaderBackground", "loaderFontColor", "loaderSpinnerColor", "loaderSpinnerBackground", "timezoneId", "itemDimensions", "apiHost"]; t < i.length; t++) {
          var r = i[t],
              n = e[r];
          n && (this[r] = n);
        }

        e.appServer && (this.appServer = it(e.appServer));
      }
    }
  }, {
    key: "connectedCallback",
    value: function () {
      l(n(s.prototype), "connectedCallback", this).call(this);
    }
  }, {
    key: "disconnectedCallback",
    value: function () {
      l(n(s.prototype), "disconnectedCallback", this).call(this), this._resizeObserver.disconnect();

      for (var e = 0, t = Object.keys(this.promises); e < t.length; e++) {
        var i = t[e];
        this.promises[i].reject(new Error("Dashboard component was removed"));
      }
    }
  }, {
    key: "firstUpdated",
    value: function () {
      var e;
      Me._components.push(this), this.containerWidth = this.container.clientWidth, this.params = this._setOptions(), et(this), Ye(this), this._setupLoader(), this.params.error || (this._loaderStyles(), "function" != typeof window.__cumulioMessageHandler && (window.__cumulioMessageHandler = function (e) {
        var t,
            i = Me._components.find(function (t) {
          return e.data.name === t._iframeId;
        });

        if (i) switch (null === (t = e.data) || void 0 === t ? void 0 : t.type) {
          case "load":
            i.dispatchEvent(new CustomEvent("load", {
              detail: {
                data: e.data
              }
            })), i._loadTimeoutHandle && (clearTimeout(i._loadTimeoutHandle), i._loadTimeoutHandle = void 0), i.iframeLoaded = !0, i.dimensions = e.data.dimensions, i._calculateDimAfterDashboardLoaded();
            break;

          case "error":
            i.dashboardError = !0, i._loadTimeoutHandle && (clearTimeout(i._loadTimeoutHandle), i._loadTimeoutHandle = void 0), i.iframeLoaded = !0, i._displayError();
            break;

          case "data":
            Pe(i, e.data.requestId, e.data.data);
            break;

          case "filters":
            Pe(i, e.data.requestId, e.data.filters);
            break;

          case "getAccessibleDashboards":
            Pe(i, e.data.requestId, e.data.accessibleDashboards);
            break;

          case "dashboardAction":
            i.dispatchEvent(new CustomEvent("dashboardAction", {
              detail: {
                data: e.data
              }
            }));
            break;

          case "export":
            e.data.error ? Te(i, e.data.requestId, e.data) : (i.dispatchEvent(new CustomEvent("exported", {
              detail: {
                data: e.data
              }
            })), Pe(i, e.data.requestId, e.data));
            break;

          case "changedFilters":
            i.dispatchEvent(new CustomEvent("changedFilters", {
              detail: {
                data: e.data
              }
            }));
            break;

          case "customEvent":
            i.dispatchEvent(new CustomEvent("customEvent", {
              detail: {
                data: e.data
              }
            }));
            break;

          case "chartsRendered":
          case "itemsRendered":
            e.data.type = "itemsRendered", i.dispatchEvent(new CustomEvent("itemsRendered", {
              detail: {
                data: e.data
              }
            }));
            break;

          case "setEditMode":
            e.data.error ? Te(i, e.data.requestId, e.data) : (Pe(i, e.data.requestId, e.data), i.params.editMode = e.data.editMode, i._containerStyle = He(i), i.dimensions && Je(i));
            break;

          case "setFilters":
          case "setPreview":
            e.data.error ? Te(i, e.data.requestId, e.data) : Pe(i, e.data.requestId, e.data);
        }
      }, window.addEventListener("message", window.__cumulioMessageHandler, !1)), this._iframeUrl = nt(this), null === (e = this.iframe) || void 0 === e || e.setAttribute("src", this._iframeUrl), this.iframeStyle = Ne(this)), this.container && this._resizeObserver.observe(this.container);
    }
  }, {
    key: "updated",
    value: function (e) {
      var t,
          i = new Set(["dashboardId", "dashboardSlug", "itemId", "language", "editMode", "screenMode", "switchScreenModeOnResize", "authToken", "authKey", "appServer", "timezoneId", "itemDimensions"]),
          r = f(e.entries());

      try {
        for (r.s(); !(t = r.n()).done;) {
          var n = u(t.value, 1)[0];
          i.has(n) && "editMode" !== n ? (this.iframeLoaded = !1, this._loadTimeoutHandle && clearTimeout(this._loadTimeoutHandle), this._loadTimeoutHandle = setTimeout(function () {
            console.error("Failed to load dashboard, appServer is likely down or unreachable.");
          }, 15e3), this.params = this._setOptions(), et(this), this._setupLoader(), this._loaderStyles(), this._iframeUrl = nt(this), this.iframe && this._updateIframeUrl(), this.iframeStyle = Ne(this)) : i.has(n) && "editMode" === n && (this.iframeLoaded && this.setEditMode(this.editMode), this.params = this._setOptions());
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
    }
  }, {
    key: "_setOptions",
    value: function () {
      var e = {
        dashboardId: this.dashboardId,
        dashboardSlug: this.dashboardSlug
      };
      return this.itemId ? (e.itemId = this.itemId, this._itemEmbedding = !0) : this._itemEmbedding = !1, this.language && (e.language = this.language), this.screenMode && (e.screenMode = this.screenMode), e.switchScreenModeOnResize = this.switchScreenModeOnResize, this.authToken && (e.token = this.authToken), this.authKey && (e.key = this.authKey), this.editMode && (e.editMode = this.editMode), this.mainColor && (e.mainColor = this.mainColor), this.accentColor && (e.accentColor = this.accentColor), this.loaderBackground && (e.loaderBackground = this.loaderBackground), this.loaderFontColor && (e.loaderFontColor = this.loaderFontColor), this.loaderSpinnerColor && (e.loaderSpinnerColor = this.loaderSpinnerColor), this.loaderSpinnerBackground && (e.loaderSpinnerBackground = this.loaderSpinnerBackground), this.timezoneId && (e.timezoneId = this.timezoneId), this.itemDimensions && (e.itemDimensions = this.itemDimensions), this.appServer ? (this.appServer = it(this.appServer), e.appServer = this.appServer) : (this.appServer = it(rt.appServer), e.appServer = this.appServer), this.apiHost ? (this.apiHost = it(this.apiHost), e.apiHost = this.apiHost) : (this.apiHost = this.appServer.endsWith("cumul.io/") ? this.appServer.replace("app", "api") : this.appServer, e.apiHost = this.apiHost), e;
    }
  }, {
    key: "_updateIframeUrl",
    value: function () {
      var e, t;
      e = this.iframe, t = this._iframeUrl, e.contentWindow.location.replace(t);
    }
  }, {
    key: "_setupLoader",
    value: function () {
      var e = Qe(this);
      this._loaderMsg = e.loadingMsg, e.errorMsg && (this.browserError = !0, this.browserErrorMsg = e.errorMsg, this._displayError());
    }
  }, {
    key: "_displayError",
    value: function () {
      this.dashboardError && (this._loaderStyles(), this.iframeStyle.opacity = 1), this.browserError && (this._containerStyle.display = "none");
    }
  }, {
    key: "_calculateDimAfterDashboardLoaded",
    value: function () {
      this.dashboardError = !1, this._loaderStyles(), Xe(this);
    }
  }, {
    key: "_loaderStyles",
    value: function () {
      var e, t, i, r, n, o;
      this._containerStyle = He(this), this._loaderStyle = function (e) {
        var t = e.params.loaderBackground || je.loaderBackground;

        if (e.params.itemEmbedding) {
          e.loaderSize = 24, e.borderWidth = 4, e.minHeight = 200;
          var i = e.params.itemDimensions.width || je.itemDimensions.width,
              r = e.params.itemDimensions.height || je.itemDimensions.height,
              n = "auto" !== r;
          return {
            background: t,
            width: "auto" !== i ? "".concat(i, "px") : "100%",
            height: "".concat(n ? r : "200", "px"),
            "min-height": n ? "" : "200px"
          };
        }

        return {
          background: t
        };
      }(this), this._loadingCircleStyle = (t = je.loaderSpinnerColor, i = je.loaderSpinnerBackground, r = Ue((e = this).borderWidth, e.params.loaderSpinnerColor || t), n = Ue(e.borderWidth, e.params.loaderSpinnerBackground || i), o = "".concat(e.loaderSize, "px"), {
        "border-top": r,
        "border-right": r,
        "border-bottom": n,
        "border-left": n,
        width: o,
        height: o
      }), this._containerLoaderStyle = function (e) {
        var t = e.params.itemDimensions.height || je.itemDimensions.height,
            i = e.params.itemEmbedding && "auto" !== t;
        return {
          display: e.iframeLoaded ? "none" : "",
          height: "".concat(i ? t : e.minHeight, "px")
        };
      }(this), this._lcStyle = function (e) {
        var t = e.params.itemDimensions.height || je.itemDimensions.height,
            i = e.params.itemEmbedding && "auto" !== t,
            r = function (t) {
          return "".concat((t - e.loaderSize - 32) / 2, "px");
        },
            n = e.params.itemId ? r(i ? Number.parseInt("".concat(t), 10) : e.minHeight) : "128px";

        return {
          padding: "".concat(n, " 16px")
        };
      }(this);
    }
  }, {
    key: "render",
    value: function () {
      return te(We || (We = c(["\n      <div class='dashboard-container' style=", ">\n        ", "\n      </div>\n      ", "\n    "])), ke(this._containerStyle), this.dashboardId || this.dashboardSlug ? te(Le || (Le = c(["\n            <div\n              class='cio-container-loader'\n              id='cio-container-loader-", "'\n              style=", "\n            >\n              <div\n                class='cio-loader'\n                id='cio-loader-", "'\n                style=", "\n              >\n                <div class='cio-lc' style=", ">\n                  <div\n                    class='cio-loading-circle'\n                    style=", "\n                  ></div>\n                  ", "\n                </div>\n              </div>\n            </div>\n\n            <iframe\n              class='cio-embed-dashboard'\n              id='", "'\n              name='", "'\n              style=", "\n              frameborder='0'\n            ></iframe>\n          "])), this._containerId, ke(this._containerLoaderStyle), this._containerId, ke(this._loaderStyle), ke(this._lcStyle), ke(this._loadingCircleStyle), this._itemEmbedding ? "" : te(Be || (Be = c(["\n                      <div\n                        class='cio-loading-message'\n                        style=", "\n                      >\n                        ", "\n                      </div>"])), ke({
        color: this.loaderFontColor
      }), this._loaderMsg), this._iframeId, this._iframeId, ke(this.iframeStyle)) : te(qe || (qe = c(["\x3c!-- the dashboard will inititialize when you provide a dashboardSlug or a dashboardId --\x3e"]))), this.browserError ? te(Fe || (Fe = c(["\n          <div id='cio-error-", "'>\n            <h3 class='cio-error'>", "</h3>\n          </div>"])), this._containerId, this.browserErrorMsg) : "");
    }
  }, {
    key: "getDashboards",
    value: function () {
      return new Promise(function (e, t) {
        return e(Me._components);
      });
    }
  }, {
    key: "getData",
    value: function (e) {
      return function (e, t, i) {
        if (null != t && t.contentWindow) {
          var r = _();

          return t.contentWindow.postMessage({
            action: "getData",
            id: i,
            _version: e.VERSION,
            requestId: r
          }, "*"), new Promise(function (t, i) {
            e.promises[r] = {
              resolve: t,
              reject: i
            }, setTimeout(function () {
              e.promises[r] && (e.promises[r].reject(new Error("getData request timed out.")), delete e.promises[r]);
            }, 2e3);
          });
        }

        return Promise.reject(new Error("Cannot retrieve contentWindow."));
      }(this, this.iframe, e);
    }
  }, {
    key: "getFilters",
    value: function () {
      return function (e, t) {
        if (null != t && t.contentWindow) {
          var i = _();

          return t.contentWindow.postMessage({
            action: "getFilters",
            _version: e.VERSION,
            requestId: i
          }, "*"), new Promise(function (t, r) {
            e.promises[i] = {
              resolve: t,
              reject: r
            }, setTimeout(function () {
              e.promises[i] && (e.promises[i].reject(new Error("getFilters request timed out.")), delete e.promises[i]);
            }, 2e3);
          });
        }

        return Promise.reject(new Error("Cannot retrieve contentWindow."));
      }(this, this.iframe);
    }
  }, {
    key: "setFilters",
    value: function (e, t) {
      return function (e, t, i, r) {
        if (t) {
          var n = _();

          return t.contentWindow.postMessage({
            action: "setFilters",
            itemId: i,
            filters: r,
            _version: e.VERSION,
            requestId: n
          }, "*"), new Promise(function (t, i) {
            e.promises[n] = {
              resolve: t,
              reject: i
            }, setTimeout(function () {
              e.promises[n] && (e.promises[n].reject(new Error("setFilters request timed out.")), delete e.promises[n]);
            }, 2e3);
          });
        }

        return Promise.reject();
      }(this, this.iframe, e, t);
    }
  }, {
    key: "setAuthorization",
    value: function (e, t) {
      return function (e, t, i, r) {
        return t ? (t.contentWindow.postMessage({
          action: "setAuthorization",
          key: i,
          token: r,
          _version: e.VERSION
        }, "*"), Promise.resolve()) : Promise.reject(new Error("Cannot retrieve contentWindow."));
      }(this, this.iframe, e, t);
    }
  }, {
    key: "refreshData",
    value: function (e) {
      return e ? Ge(this, this.iframe, e) : Ge(this, this.iframe);
    }
  }, {
    key: "reloadDashboard",
    value: function () {
      return e = this, (t = this.iframe) ? (t.contentWindow.postMessage({
        action: "reloadDashboard",
        _version: e.VERSION
      }, "*"), Promise.resolve()) : Promise.reject(new Error("Cannot retrieve contentWindow."));
      var e, t;
    }
  }, {
    key: "exportDashboard",
    value: function (e) {
      return e ? Ve(this, this.iframe, e) : Ve(this, this.iframe);
    }
  }, {
    key: "getAccessibleDashboards",
    value: function () {
      return Ke(this, this.iframe);
    }
  }, {
    key: "setEditMode",
    value: function (e) {
      return function (e, t, i) {
        if (t && t.contentWindow) {
          var r = _();

          return e.params.editMode === i ? Promise.reject(new Error("editMode parameter is currently already set to " + i)) : "editFull" !== i && "editLimited" !== i && "view" !== i ? Promise.reject(new Error("The editMode parameter must be one of the following values: 'editFull', 'editLimited' or 'view'.")) : (t.contentWindow.postMessage({
            action: "setEditMode",
            editMode: i,
            _version: e.VERSION,
            requestId: r
          }, "*"), new Promise(function (t, i) {
            e.promises[r] = {
              resolve: t,
              reject: i
            };
          }));
        }

        return Promise.reject(new Error("Cannot retrieve contentWindow."));
      }(this, this.iframe, e);
    }
  }, {
    key: "setPreview",
    value: function (e) {
      return function (e, t, i) {
        if (t) {
          var r = _();

          return t.contentWindow.postMessage({
            action: "setPreview",
            preview: i,
            requestId: r,
            _version: e.VERSION
          }, "*"), new Promise(function (t, i) {
            e.promises[r] = {
              resolve: t,
              reject: i
            }, setTimeout(function () {
              e.promises[r] && (e.promises[r].reject(new Error("setPreview request timed out.")), delete e.promises[r]);
            }, 2e3);
          });
        }

        return Promise.reject(new Error("Cannot retrieve contentWindow."));
      }(this, this.iframe, e);
    }
  }], [{
    key: "styles",
    get: function () {
      return [Ze];
    }
  }]), s;
}();

g([Ee(".dashboard-container"), v("design:type", HTMLElement)], ot.prototype, "container", void 0), g([Ee("iframe"), v("design:type", HTMLIFrameElement)], ot.prototype, "iframe", void 0), g([$e(), v("design:type", Object)], ot.prototype, "dashboardId", void 0), g([$e(), v("design:type", Object)], ot.prototype, "dashboardSlug", void 0), g([$e(), v("design:type", Object)], ot.prototype, "itemId", void 0), g([$e(), v("design:type", Object)], ot.prototype, "language", void 0), g([$e(), v("design:type", Object)], ot.prototype, "screenMode", void 0), g([$e({
  converter: {
    fromAttribute: function (e) {
      return "true" === e;
    },
    toAttribute: function (e) {
      return String(e);
    }
  }
}), v("design:type", Object)], ot.prototype, "switchScreenModeOnResize", void 0), g([$e(), v("design:type", Object)], ot.prototype, "editMode", void 0), g([$e(), v("design:type", Object)], ot.prototype, "mainColor", void 0), g([$e(), v("design:type", Object)], ot.prototype, "accentColor", void 0), g([$e(), v("design:type", Object)], ot.prototype, "authToken", void 0), g([$e(), v("design:type", Object)], ot.prototype, "authKey", void 0), g([$e(), v("design:type", Object)], ot.prototype, "loaderBackground", void 0), g([$e(), v("design:type", Object)], ot.prototype, "loaderFontColor", void 0), g([$e(), v("design:type", Object)], ot.prototype, "loaderSpinnerColor", void 0), g([$e(), v("design:type", Object)], ot.prototype, "loaderSpinnerBackground", void 0), g([$e(), v("design:type", Object)], ot.prototype, "appServer", void 0), g([$e(), v("design:type", Object)], ot.prototype, "timezoneId", void 0), g([$e(), v("design:type", Object)], ot.prototype, "apiHost", void 0), g([$e({
  type: Object
}), v("design:type", Object)], ot.prototype, "itemDimensions", void 0), g([$e({
  attribute: !1
}), v("design:type", String)], ot.prototype, "_containerId", void 0), g([$e({
  attribute: !1
}), v("design:type", String)], ot.prototype, "_iframeId", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "params", void 0), g([$e({
  attribute: !1
}), v("design:type", String)], ot.prototype, "_iframeUrl", void 0), g([$e({
  attribute: !1
}), v("design:type", Boolean)], ot.prototype, "iframeLoaded", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "promises", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "iframeStyle", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "_containerStyle", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "_loaderStyle", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "_lcStyle", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "_loadingCircleStyle", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "_containerLoaderStyle", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "_loaderMsg", void 0), g([$e({
  attribute: !1
}), v("design:type", Number)], ot.prototype, "containerWidth", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "dimensions", void 0), g([$e({
  attribute: !1
}), v("design:type", String)], ot.prototype, "currentScreenMode", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "_itemEmbedding", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "browserError", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "browserErrorMsg", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "dashboardError", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "browserNotSupported", void 0), g([$e({
  attribute: !1
}), v("design:type", Object)], ot.prototype, "VERSION", void 0), ot = g([(e => t => "function" == typeof t ? ((e, t) => (customElements.define(e, t), t))(e, t) : ((e, t) => {
  const {
    kind: i,
    elements: r
  } = t;
  return {
    kind: i,
    elements: r,

    finisher(t) {
      customElements.define(e, t);
    }

  };
})(e, t))("cumulio-dashboard"), v("design:paramtypes", [Object])], ot);

var name = "@cumul.io/react-cumulio-dashboard";
var version = "3.2.0";
var typings = "./index.d.ts";
var dependencies = {
	"@lit-labs/react": "1.1.1"
};
var devDependencies = {
	"@types/uuid": "^8.3.1"
};
var peerDependencies = {
	react: "^16 || ^17 || ^18",
	"react-dom": "^16 || ^17 || ^18"
};
var keywords = [
	"react",
	"react-cumulio",
	"cumulio",
	"front-end",
	"development",
	"dashboard",
	"visualization",
	"chart",
	"component"
];
var pkg = {
	name: name,
	version: version,
	typings: typings,
	dependencies: dependencies,
	devDependencies: devDependencies,
	peerDependencies: peerDependencies,
	keywords: keywords
};

const CumulioDashboardComponent = createComponent(React, 'cumulio-dashboard', ot, {
  itemsRendered: 'itemsRendered',
  load: 'load',
  changedFilters: 'changedFilters',
  customEvent: 'customEvent',
  exported: 'exported',
  dashboardAction: 'dashboardAction'
});
CumulioDashboardComponent.defaultProps = {
  VERSION: pkg.version + '-react-cumulio'
};

export { CumulioDashboardComponent };
